export default "__VITE_ASSET__88ba3eed__"